var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"cancel",on:{"click":function($event){return _vm.cancelOrder(_vm.orderDetail.orderNo)}}},[_vm._v("取消订单")]),_c('div',{staticClass:"payment",on:{"click":function($event){return _vm.payOrder(_vm.orderDetail.orderNo)}}},[_vm._v("立即支付")])])
}
var staticRenderFns = []

export { render, staticRenderFns }